import { formatWithCents } from '@/components/ui/currency-input';

const centsToDollars = (cents: number) => {
  return String(cents / 100);
};

const centsToInitialValue = (cents: number): string => {
  return formatWithCents(String(centsToDollars(cents)));
};

const currencyInputValueToCents = (value: string): number => {
  return Number(value.split('.').join(''));
};

const centsToDollarsWithCommas = (cents: number): string => {
  return centsToDollars(cents).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export {
  centsToDollars,
  centsToDollarsWithCommas,
  centsToInitialValue,
  currencyInputValueToCents,
};
